import { useConfigureBuyCloudRoutes } from "ls/features/buy/useConfigureBuyCloudRoutes";
import { useConfigureEnterpriseRoutes } from "ls/features/enterprise/useConfigureEnterpriseRoutes";
import { useConfigureOnPremRoutes } from "ls/features/onprem-setup/useConfigureOnPremRoutes";

export function useConfigureRoutes() {
  useConfigureBuyCloudRoutes();
  useConfigureEnterpriseRoutes();
  useConfigureOnPremRoutes();
}
